<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div slot="content" class="cv-delete">
      <div class="header flex-between">
        <span class="title">{{cvInfo.title}}</span>
        <span class="iconfont iconx" @click="handleClose"/>
      </div>
      <p v-if="cvInfo.type === 'delete'" class="message">此简历状态为{{cvInfo.cvStatusText}}，删除后以下 HR 将无法继续查看你的简历</p>
      <p v-if="cvInfo.type === 'change'" class="message">更改简历为私密后，以下 HR 将无法继续查看你的简历</p>
      <div class="inbox-container">
        <template v-for="(item, index) in applies">
          <p class="hr" :key="index" v-if="index < 2">
            <span>{{ item.company }}</span>
            <span>{{ item.positoin }}</span>
            <span>丨</span>
            <span>{{ item.name }}</span>
          </p>
        </template>
        <p class="hr-bottom hr" v-show="applies.length > 2" @click="viewAllApplies">查看全部 HR ＞</p>
      </div>
      <p class="warning">{{ cvInfo.warning }}</p>
      <button class="theme-button delete-footer flex-center" @click="handleClick">确定</button>
    </div>
  </w-dialog>
</template>

<script>
  import WDialog from '@/components/global/w-dialog'
  import { mapState } from 'vuex'
  import { componentsMixin } from '@/assets/js/mixin/components'

  export default {
    props: {
      cvInfo: {
        type: Object,
        default: null
      },
      state: {
        type: Boolean,
        default: false
      }
    },
    mixins: [componentsMixin],
    data () {
      return {}
    },
    components: {
      WDialog
    },
    watch: {},
    computed: {
      ...mapState('cv', [ 'applies' ])
    },
    methods: {
      handleClose () {
        this.$emit('handleClose')
      },
      viewAllApplies () {
        window.location.href = '/inbox'
        // this.routeTo('/inbox')
      },
      handleClick () {
        if (this.cvInfo.type === 'delete') {
          this.$emit('deleteCv')
        } else if (this.cvInfo.type === 'change') {
          this.$emit('changeCv')
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .cv-delete {
    background-color: $color-light;
    width: 90vw;
    border-radius: 4px;
    padding: 32px 24px 24px;
    .header {
      margin-bottom: 18px;
      .title {
        color: $color-title;
        font-size: $font-size-medium-x;
        font-weight: 500;
      }
      .iconfont {
        color: #8c8c8c;
      }
    }
    .message {
      line-height: 22px;
      color: $color-dark-gray;
      margin-bottom: 12px;
    }
    .inbox-container {
      border-radius: 2px;
      background-color: #F9F9F9;
      padding: 14px 16px 12px;
      margin-bottom: 18px;
      .hr {
        line-height: 24px;
        margin-bottom: 6px;
        max-width: 255px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        span {
          color: $color-dark-gray;
        }
      }
      .hr-bottom {
        text-align: right;
        margin-bottom: 0;
        color: $color-light-gray;
      }
    }
    .warning {
      color: $color-theme;
      font-size: 15px;
      line-height: 24px;
      font-weight: 400;
      margin-bottom: 24px;
    }
    .delete-footer {
      border-radius: 4px;
      height: 40px;
      width: 100%;
      font-size: $font-size-medium-x;
    }
  }
</style>
